import Box from '@elementor/ui/Box';
import Typography from '@elementor/ui/Typography';
import { styled } from '@elementor/ui/styles';
import GetFreeButton from '@components/get-free-button';
import { useAnalytics } from '@hooks/use-analytics';
import GoogleAnalyticsEvent, {
	EVENT_SECTIONS,
	EVENT_TYPES,
} from '@hooks/use-analytics/google-analytics-event';
import BoltStarIcon from '@images/boltstar-icon';
import { __ } from '@utils/i18n';

const ScannerFooter = () => {
	const { sendEvent } = useAnalytics();

	const onGetFreeButtonClick = () => {
		sendEvent(
			new GoogleAnalyticsEvent()
				.setType(EVENT_TYPES.CTA)
				.setSection(EVENT_SECTIONS.SIDEBAR)
				.setElementName('get it free button')
				.setOutcome('opening the download popup')
				.setEnglishText('Get it free')
				.setLevelOne('sticky'),
		);
	};

	return (
		<StyledFooterContainer>
			<StyledFooterTextContainer>
				<BoltStarIcon />

				<Box>
					<StyledFooterHeading as="p" variant="subtitle1">
						{__('Ally can fix these for you!')}
					</StyledFooterHeading>

					<StyledFooterSubHeading as="p" variant="body2">
						{__('Improve accessibility in seconds.')}
					</StyledFooterSubHeading>
				</Box>
			</StyledFooterTextContainer>

			<GetFreeButton onClick={onGetFreeButtonClick} />
		</StyledFooterContainer>
	);
};

const StyledFooterContainer = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;

	position: absolute;
	right: 0;
	left: 0;
	bottom: 0;

	padding: ${({ theme }) => theme.spacing(2)};

	background: linear-gradient(
		180deg,
		rgba(255, 255, 255, 1) 25%,
		rgba(201, 208, 252, 1) 100%
	);
	filter: drop-shadow(0 -4px 40px rgba(40, 71, 243, 0.4));

	&::before {
		content: '';

		height: 30px;
		width: 100%;

		position: absolute;
		top: -10px;
		left: 0;
		right: 0;
		z-index: -1;

		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='420' height='30' fill='none' preserveAspectRatio='xMidYMid slice' viewBox='0 0 420 30'%3E%3Cg filter='url(%23filter0_d_109_17880)' transform='translate(-40 -44)'%3E%3Cpath fill='%23fff' d='m323.586 48.902.703-.804A12 12 0 0 1 333.32 44H452a8 8 0 0 1 8 8v75H40V52a8 8 0 0 1 8-8h119.555c3.46 0 6.752 1.494 9.031 4.098l.703.804A12 12 0 0 0 186.32 53h128.235c3.46 0 6.752-1.494 9.031-4.098'/%3E%3C/g%3E%3C/svg%3E");
		background-size: 100%;
		background-repeat: no-repeat;
	}
`;

const StyledFooterTextContainer = styled(Box)`
	display: flex;
	align-items: flex-start;

	gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledFooterHeading = styled(Typography)`
	margin: 0;
	margin-bottom: ${({ theme }) => theme.spacing(0.5)};

	color: #1d4ed8;
	font-weight: 500;
	line-height: 18px;
	letter-spacing: 0.15px;
`;

const StyledFooterSubHeading = styled(Typography)`
	margin: 0;

	color: ${({ theme }) => theme.palette.text.secondary};
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.15px;
`;

export default ScannerFooter;
